function CVSummary() {
    return (
        <p>
            I’m a Software Engineer based in Belgium specialized in <strong>Java back-end</strong> software with{" "}
            <strong>experience in technical architecture</strong> and <strong>leadership</strong>. I also really{" "}
            like <strong>teaching</strong>, <strong>coaching</strong>, and <strong>presenting technical{" "}
            topics</strong>. I believe that when you share knowledge, you also improve and refine your own{" "}
            understanding of it over time: it’s a win-win solution in which both parties grow.
        </p>
    )
}

export default CVSummary